const initialAgentWallet = {
  walletData: {},
  wallets: { isBusy: false, records: {} },
};

const initialAgents = {
  agent: initialAgentWallet,
  agentHierarchy: {
    isLoading: false,
    agents: [],
  },
};

export default initialAgents;
